import type { RouteObject } from "react-router-dom";
import Layout from "@/components/feature/Layout";
import NotFound from "@/pages/NotFound";
import Home from "@/pages/home/page";
import ChannelPage from "@/pages/channel/page";
import ArticlePage from "@/pages/article/page";
import About from "@/pages/about/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Layout />,
    children: [
      { index: true, element: <Home /> },
      { path: "channel/:slug", element: <ChannelPage /> },
      { path: "news/:id", element: <ArticlePage /> },
      { path: "about", element: <About /> },
      { path: "*", element: <NotFound /> },
    ],
  },
];

export default routes;